// Port of api/fuel/app/classes/insights/size/lifespan.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'

function excludeExpansions(ownerId) {
	var config = Config.user(ownerId)
	return !!(((config || {}).insights || {}).size || {}).expansions
}

function dateParts(timestamp) {
	var d = new Date(timestamp * 1000)
	return {
		year: d.getUTCFullYear(),
		month: d.getUTCMonth(),
		day: d.getUTCDate()
	}
}

function quarterBucket(added, removed) {
	var start = dateParts(added)
	var end = dateParts(removed)
	var months = ((end.year - start.year) * 12) + (end.month - start.month)
	if (end.day < start.day) months--
	months = Math.floor(months / 3)
	if (months > 39) months = 39
	if (months < 0) months = 0
	return months
}

export default Segment.extend({
	name: 'lifespan',
	types: [Constants.TYPE_USER],
	insight: ['lifespan.expansions', 'lifespan.period'],
	detail: ['lifespan'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		if (!owner.get_count_collection()) return {}

		var exclude = excludeExpansions(vars && vars.sessionUserId)
		var period = (filter && filter['lifespan.period'] !== undefined) ? parseInt(filter['lifespan.period'], 10) : 0
		var lifespan = Array(40).fill(0)
		var gameIndex = Array(40).fill(null).map(function() { return [] })
		var gameTrack = {}
		var logs = Util.queryFast(
			'SELECT g.game_name AS n, g.game_type AS t, l.log_date AS d, l.log_context AS c, l.game_id AS g' +
			' FROM log_user_collection l, game g' +
			' WHERE l.user_id = ' + owner.get_id() +
			' AND l.game_id = g.game_id' +
			' ORDER BY g.game_sortname ASC, l.log_date ASC, l.log_id ASC'
		)

		for (var i = 0; i < logs.length; i++) {
			var log = logs[i]
			var gameId = parseInt(log.g, 10)
			if (!gameTrack[gameId]) {
				gameTrack[gameId] = {
					id: gameId,
					t: parseInt(log.t, 10),
					added: 0,
					removed: 0,
					name: log.n
				}
			}
			gameTrack[gameId][parseInt(log.c, 10) === Constants.LOG_CONTEXT_ADDED ? 'added' : 'removed'] = parseInt(log.d, 10)
			if (parseInt(log.c, 10) === Constants.LOG_CONTEXT_ADDED && gameTrack[gameId].removed) gameTrack[gameId].removed = 0
		}

		var longest = false
		var shortest = false
		var average = 0
		var trackIds = Object.keys(gameTrack)

		for (var j = 0; j < trackIds.length; j++) {
			var game = gameTrack[trackIds[j]]
			var removed = game.removed || Math.floor(Date.now() / 1000)
			var added = game.added
			if (!added || !removed) continue

			var diff = removed - added
			average += diff

			if (!exclude || game.t === Constants.GAME_TYPE_BASE) {
				if (longest === false || diff > longest.diff) {
					longest = {
						diff: diff,
						added: added,
						removed: removed,
						game: game.name,
						active: !game.removed
					}
				}
				if (game.removed && (shortest === false || diff < shortest.diff)) {
					shortest = {
						diff: diff,
						added: added,
						removed: removed,
						game: game.name
					}
				}
			}

				if (!period || (period === 1 && !game.removed) || (period === 2 && game.removed)) {
					if (!exclude || game.t === Constants.GAME_TYPE_BASE) {
						var months = quarterBucket(added, removed)
						lifespan[months]++
						gameIndex[months].push(game)
					}
			}
		}

		this._data.lifetime_overview = {
			average: trackIds.length ? Math.round(average / trackIds.length) : 0,
			longest: longest,
			shortest: shortest
		}

		if (detail) {
			var games = []
			var bucket = parseInt(vars.index, 10) || 0
			for (var k = 0; k < gameIndex[bucket].length; k++) {
				var item = gameIndex[bucket][k]
				this._references.games.push(item.id)
				games.push({
					id: item.id,
					added: item.added,
					removed: item.removed
				})
			}
			return { games: games }
		}

		return {
			lifespan: lifespan,
			overview: {
				lifetime: this._data.lifetime_overview
			}
		}
	}
})
